import { getGtmDataLayer } from '@airasia-common/libraries/factories/Analytics';
import { GA_LABELS, GA_EVENTS } from '../../constants';
import { types } from './booking.meta';

const LOGINED = 'loggedIn';
const NON_LOGIN = 'non-loggedIn';
const HOTEL_BOOKING_TRACKING = 'Hotels SA';
const CANCEL_BOOKING = 'Cancel Booking';
export default {
  [types.FIRST_LOAD_BOOKING]: ({
    payload: {
      checkin,
      checkout,
      lengthOfStay,
      numberOfRoom,
      currency,
      adultAndChild,
      isLogin,
    },
  }) => {
    try {
      return {
        hotelCheckInDate: checkin,
        hotelCheckOutDate: checkout,
        hotelLengthOfStay: lengthOfStay,
        hotelNumberOfRooms: numberOfRoom,
        AdultsAndChildren: adultAndChild, // adult number | children numbers
        userCurrency: currency,
        lineofbusiness: HOTEL_BOOKING_TRACKING,
        loginstatus: isLogin ? LOGINED : NON_LOGIN,
      };
    } catch (error) {
      console.log(error);
      return {};
    }
  },
  [types.CANCEL_BOOKING_BUTTON_CLICK]: ({ payload: { bookId, hotelId } }) =>
    getGtmDataLayer(
      GA_EVENTS.trackEventNoEcommerce,
      'Hotel Booking Detail Heatmap',
      'click',
      `${bookId}|${hotelId}|${CANCEL_BOOKING}`
    ),
  [types.CANCEL_BOOKING_CLICK]: ({ payload: { bookId, hotelId, reason } }) =>
    getGtmDataLayer(
      GA_EVENTS.trackEventNoEcommerce,
      'Hotel Booking Detail Heatmap',
      `${bookId}|${hotelId}`,
      reason
    ),
  [types.KEEP_BOOKING_CLICK]: ({ payload: { bookId, hotelId } }) =>
    getGtmDataLayer(
      GA_EVENTS.trackEventNoEcommerce,
      'Hotel Booking Detail Heatmap',
      `${bookId}|${hotelId}`,
      GA_LABELS.keepBooking
    ),
  // Will get custom format
  [types.FIRST_LOAD_BOOKING]: ({ payload }) => payload,
};
